var selectCallback = function(variant, selector) {
  // BEGIN SWATCHES
  if (variant) {
    var form = jQuery('#' + selector.domIdPrefix).closest('form');
    for (var i=0,length=variant.options.length; i<length; i++) {
      var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] +'"]');
      if (radioButton.size()) {
        radioButton.get(0).checked = true;
      }
    }
  }
  // END SWATCHES
};

jQuery(document).ready(function(){
  var window_height = jQuery(window).height();
  var header_height = jQuery('header.site-header').height();
  var pro_img_height = window_height - header_height - 30;
  pro_img_height = pro_img_height+'px';
  jQuery('.product__photo--single img').css('height',pro_img_height);
  
   jQuery('.media_slider_p').slick({
     arrows: true,
      infinite: true,
     dots:true,
      slidesToShow: 1,
      slidesToScroll: 1
    }); 
  if(jQuery(window).width() <= 749){
    /* jQuery('.gallery_items').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      arrows: false,
    }); */
    jQuery('.what_includes').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      arrows: false,
    });
    
  }
  jQuery(document).on("click", '.ajaxcart_pro_remove', function(){    
  	jQuery(this).parent().parent().find('.ajaxcart__qty-num[type="text"]').val(0);
    jQuery(this).parent().parent().find('.ajaxcart__qty--minus').click();
  });
  /*
  jQuery(window).on( 'scroll' , function() {
    var b = jQuery(this).scrollTop();    
    if (b > 55) { 
      jQuery(".site-header").addClass("sticky");
      jQuery("main").css("margin-top","145px");
    }else{
      jQuery(".site-header").removeClass("sticky");
      jQuery("main").css("margin-top","0px");
    }
  }); */
  
});

jQuery(window).resize(function(){

  if(jQuery(window).width() <= 749){
    /* jQuery('.gallery_items').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      arrows: false,
    }); */
    jQuery('.what_includes').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      arrows: false,
    });
  }else{
    //jQuery('.gallery_items').slick('unslick');  
    //jQuery('.what_includes').slick('unslick');  
  }  
  
  var window_height = jQuery(window).height();
  var header_height = jQuery('header.site-header').height();
  var pro_img_height = window_height - header_height;
  pro_img_height = pro_img_height+'px';
  jQuery('.product__photo--single img').css('height',pro_img_height);
  
});
